import { BasicComponent } from "haxt";

import "./HomePage.scss";
import { Hero } from "../components/sections/Hero";
import { CardSection } from "../components/sections/CardSection";
import { CardMedia } from "../components/cards/CardMedia";
import { CardItem } from "../components/cards/CardItem";
import { GridSection } from "../components/sections/GridSection";
import { Section } from "./data/data-types";
import { CardImage } from "../components/cards/CardImage";
import { Session } from "../@noxtum/session/Session";
import { Router } from "../@noxtum/router/Router";
import { RouterLink } from "../@noxtum/router/RouterLink";
import { GridGallery } from "../components/sections/GridGallery";

const data: {
	sections: (Section | (() => JSX.Element))[];
} = {
	sections: [
		{
			type: "hero",
			options: {
				align: "left",
				classes: {
					"home-hero": true
				},
			},
			data: {
				badge: "Featured",
				title: "The Burren, Ireland Ancient Sea",
				subtitle: "By Dr. Keith McLemon",
				background: {
					type: "video",
					src: "/images/banner.mp4",
					loop: true
				},
				link: "#"
			}
		},
		/*() => {
			return (<GridSection class="home-logo" style="margin: 0;">
				<div class="box" style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
					<img src="/images/gsi-rectangle-clear-large.png" alt="GSI Logo" style="max-width: 800px;" />
				</div>
			</GridSection>);
		},*/
		() => {
			return (<GridSection class="full-content" style="margin: 20px 0;">
				<div class="box" style="grid-area: a; display: flex; flex-direction: column; justify-content: center;">
					<h2 style="text-align: center;">Welcome Message</h2>
					<p style="text-align: center;">
						The Geographical Society of Ireland (GSI) is the professional representative organisation of
						geographers in Ireland. The Society was founded in 1934 and since then we have been raising
						awareness of the value and impact of Geography in Ireland and beyond, through a diverse range of
						activities and collaborations.
					</p>
					<p style="text-align: center;">Explore our website to learn more about what we do!</p>
				</div>
				{/* <div class="box" style="height: 600px; grid-area: b;">
					<img src="/images/contact.jpg" alt="Contact" />
				</div> */}
			</GridSection>);
		},
		() => {
			/*
				if (loggedIn) {
					return <div class="MemberLogin">
						<h1>Verify Email</h1>
						<button type="button" onClick={this.onVerifyEmail}>Verify Email</button>
					</div>;
				} else {
					return <div class="MemberLogin">
						<h1>Verify Email</h1>
						<p>You must be logged in to verify your email</p>
						<RouterLink href="/members/login" query={{ return: window.location.pathname + window.location.search }}>Go to Login</RouterLink>
					</div>;
				}
			*/
			let loggedIn = Session.isLoggedIn();
			return (<GridSection class="join-content" style="margin: 20px 0;">
				<div class="box" style="height: 600px; grid-area: b;">
					<img src="/images/join-our-club.jpg" alt="Join Our Club" />
				</div>
				<div class="box" style="grid-area: a; display: flex; flex-direction: column; justify-content: center;">
					<h2 style="text-align: center;">Join Our Society</h2>
					<p style="text-align: center;">
						Membership is open to academics, students and members of the public with an interest in
						environmental and geographical issues. Given the rapidly changing nature of Ireland in the last few
						decades and increasing global interest in all things Irish, geography has a large part to play in
						understanding, generating debate and suggesting solutions to a range of local, national and
						international issues. We would particularly welcome new non-academic members who bring a unique
						perspective.
					</p>
					{loggedIn ?
						<RouterLink class="join-button" href="/members/area">Go to Members Area</RouterLink>
						:
						<RouterLink class="join-button" href="/members/login">Login / Register</RouterLink>
					}
				</div>
			</GridSection>);
		},
		/*{
			type: "cards",
			options: {
				columns: 3,
			},
			items: [
				{
					type: "CardItem",
					options: {
						span: "max"
					},
					data: {
						title: "Sustainable Tourism in National Parks",
						content: "Learn about sustainable tourism practices that help protect national parks while allowing visitors to enjoy their beauty...",
					},
				},
				{
					type: "CardMedia",
					options: {
						template: "info"
					},
					data: {
						title: "Unveiling the Mysteries of the Amazon Rainforest",
						content: "Delve into the heart of the Amazon Rainforest, uncovering its unparalleled biodiversity and the efforts to preserve this natural wonder...",
						media: {
							type: "icon",
							src: "/images/icons/help-icon-1.svg",
						},
					},
				},
				{
					type: "CardMedia",
					options: {
						template: "info"
					},
					data: {
						title: "Ancient Civilizations of the Mediterranean",
						content: "Explore the rise and fall of ancient civilizations around the Mediterranean Sea, from the Egyptians to the Romans...",
						media: {
							type: "icon",
							src: "/images/icons/help-icon-2.svg",
						},
					},
				},
				{
					type: "CardMedia",
					options: {
						template: "info"
					},
					data: {
						title: "The Impact of Climate Change on Coastal Cities",
						content: "Examine how rising sea levels and extreme weather events are reshaping coastal cities around the world...",
						media: {
							type: "icon",
							src: "/images/icons/help-icon-3.svg"
						},
					},
				}
			]
		},
		{
			type: "cards",
			options: {
				columns: 2,
				background: "secondary"
			},
			items: [
				{
					type: "CardMedia",
					options: {
						template: "info",
						background: "primary"
					},
					data: {
						title: "Sustainable Tourism in National Parks",
						date: new Date("2024-03-08"),
						content: "Learn about sustainable tourism practices that help protect national parks while allowing visitors to enjoy their beauty...",
						badge: { type: "date" },
						media: {
							type: "image",
							src: "/images/examples/6.jpg"
						},
						link: "#"
					},
				},
				{
					type: "CardMedia",
					options: {
						template: "info",
						background: "primary"
					},
					data: {
						title: "Urban Green Spaces and Their Benefits",
						date: new Date("2024-02-14"),
						content: "Discover the importance of urban green spaces in enhancing city living, promoting biodiversity, and improving mental health...",
						badge: { type: "date" },
						media: {
							type: "image",
							src: "/images/examples/7.jpg"
						},
						link: "#"
					},
				}
			]
		},
		{
			type: "cards",
			options: {
				columns: 2
			},
			items: [
				{
					type: "CardMedia",
					options: {
						template: "card",
						layout: "horizontal",
					},
					data: {
						title: "Sustainable Tourism in National Parks",
						date: new Date("2024-03-08"),
						content: "Learn about sustainable tourism practices that help protect national parks while allowing visitors to enjoy their beauty...",
						badge: { type: "date" },
						media: {
							type: "image",
							src: "/images/examples/6.jpg"
						},
						link: "#"
					},
				},
				{
					type: "CardMedia",
					options: {
						template: "card",
						layout: "horizontal",
					},
					data: {
						title: "Urban Green Spaces and Their Benefits",
						date: new Date("2024-02-14"),
						content: "Discover the importance of urban green spaces in enhancing city living, promoting biodiversity, and improving mental health...",
						badge: { type: "date" },
						media: {
							type: "image",
							src: "/images/examples/7.jpg"
						},
						link: "#"
					},
				},
				{
					type: "CardMedia",
					options: {
						template: "card",
						layout: "horizontal",
					},
					data: {
						title: "The Role of Geology in Shaping Landscapes",
						date: new Date("2024-01-22"),
						content: "Explore how geological processes over millions of years have shaped the diverse landscapes we see today...",
						badge: { type: "date" },
						media: {
							type: "image",
							src: "/images/examples/8.jpg"
						},
						link: "#"
					},
				},
				{
					type: "CardMedia",
					options: {
						template: "card",
						layout: "horizontal",
					},
					data: {
						title: "Cultural Heritage Sites Around the World",
						date: new Date("2023-12-05"),
						content: "Take a virtual tour of some of the most iconic cultural heritage sites around the globe and learn about their significance...",
						badge: { type: "date" },
						media: {
							type: "image",
							src: "/images/examples/9.jpg"
						},
						link: "#"
					},
				}
			]
		},*/
		/*{
			type: "grid-gallery",
			options: {
				columns: 2,
			},
			items: [
				"/images/gallery/Blackstairs_Mountain.png",
				"/images/gallery/Cut_Bog.jpg",
				"/images/gallery/Devils_Matchstick_Lichen.png",
				"/images/gallery/PXL_20240826_101236903.jpg",
				"/images/gallery/Avoca_BallymurtaghMine.png",
				"/images/gallery/PXL_20240826_115630027.jpg",
				"/images/gallery/Round-Level_Sundew.png",
				"/images/gallery/TinyFrog2.jpg"
			]
		},*/
		{
			type: "hero",
			options: {
				align: "center"
			},
			data: {
				title: "Banner section title",
				subtitle: "Banner section subtitle",
				background: {
					type: "image",
					src: "/images/background-gsi-banner-3.jpg"
				},
				link: "#"
			}
		}
	]
};

export class HomePage extends BasicComponent<{
	page: string;
	parts: string[];
}> {
	public render() {
		return (
			<div class="HomePage">
				{data.sections.map((section) => {
					if (typeof section === "function") {
						return section();
					} else if (section.type === "hero") {
						return <Hero options={section.options} data={section.data} />;
					} else if (section.type === "grid-gallery") {
						return <GridGallery options={section.options} items={section.items} />;
					} else if (section.type === "cards") {
						return (
							<CardSection options={section.options}>
								{section.items.map((item) => {
									if (item.type === "CardMedia") {
										return <CardMedia options={item.options} data={item.data} />;
									} else if (item.type === "CardItem") {
										return <CardItem options={item.options} data={item.data} />;
									} else if (item.type === "CardImage") {
										return <CardImage options={item.options} data={item.data} />;
									} else {
										return null;
									}
								})}
							</CardSection>
						);
					} else {
						return null;
					}
				})}
			</div>
		);
	}
}
